export default __webpack_public_path__ + "hall-of-fame-mobile-cn-98e37f45ba26956e0a48e1b3ddefe71b.png";